import React from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';

interface Props {}

const InstrumentAccordion = (props: React.PropsWithChildren<Props>) => {
    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                Instruments
            </AccordionSummary>
            <AccordionDetails>
                <Grid spacing={1} container>
                    {props.children}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default InstrumentAccordion;
